import React, { Fragment } from 'react';
import pt from 'prop-types';
import JoinPage from 'components/login/join';
import Logo from 'partners/components/logo';
import './login.scss';

export default class PartnerJoinPage extends React.PureComponent {
  static propTypes = {
    invited: pt.shape({
      client_name: pt.string,
    }),
    params: pt.shape({
      partnerId: pt.string,
    }),
  };

  getSubheading() {
    const { invited, params } = this.props;
    const partnerName = (
      <span className="nowrap bold capitalized">{invited.client_name}</span>
    );

    if (params?.partnerId) {
      return (
        <Fragment>
          Create an account or log in to join the&nbsp;
          {partnerName}
          &nbsp;partner team on Swell.
        </Fragment>
      );
    }

    return (
      <Fragment>
        Finish setting up the&nbsp;
        {partnerName}
        &nbsp;partner account.
      </Fragment>
    );
  }

  render() {
    return (
      <JoinPage
        {...this.props}
        logo={<Logo />}
        subheading={this.getSubheading()}
      />
    );
  }
}
